var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isElementaryStudent)?_c('HomeworksWidget',{attrs:{"dates":_vm.dates}}):_vm._e(),_c('v-divider',{staticClass:"mx-5"}),_c('ManualHomeworksWidget',{attrs:{"dates":_vm.dates}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }